import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';
import getPreloadedState from './getPreloadedState';
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { getSettings } from "../constants/setting";
var persistConfig = {
    key: 'alwayson_chatbot_' + getSettings().bot_id,
    storage: storageSession,
};
var persistedReducer = persistReducer(persistConfig, rootReducer);
var store = configureStore({
    reducer: persistedReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        });
    },
});
var configureAppStore = function (preloadedState) {
    return store;
};
export var persistor = persistStore(store);
export { getPreloadedState };
export default configureAppStore;
